import { useState, useEffect } from "react";
import { FaTimes, FaGamepad, FaFire, FaSearch } from "react-icons/fa";
import { useFetchSubjects } from "../../../hooks/homepage/useHomepage";

export default function GameModal({ isOpen, onClose, onApply }) {
  const subjectsAPI = useFetchSubjects();
  const [topics, setTopics] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);

  // Reset state whenever modal opens
  useEffect(() => {
    if (isOpen) {
      setSelectedOption(null);
      setSelectedTopic(""); 
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen && subjectsAPI.data) {
      setTopics(subjectsAPI.data.data.subjects || []);
    }
  }, [isOpen, subjectsAPI.data]);

  if (!isOpen) return null;

  const handleExploreGames = () => {
    const newFilters = {
      topic_id: selectedOption === "topic" ? selectedTopic : "",
      is_popular: selectedOption === "popular",
    };
    onApply?.(newFilters); // ✅ pass filters back to homepage
    onClose?.(); // close modal after applying
  };
  console.log("Selected Topic:", selectedTopic);
  console.log("Selected Option:", selectedOption);

  return (
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
      <div className="bg-white w-full max-w-md rounded-lg shadow-lg p-6 relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-black"
        >
          <FaTimes size={20} />
        </button>

        {/* Header */}
        <div className="flex items-center gap-2 mb-2">
          <FaGamepad className="text-green-600" size={22} />
          <h2 className="text-lg font-semibold">Discover Games</h2>
        </div>
        <p className="text-sm text-gray-600 mb-4">
          What type of games would you like to explore today?
        </p>

        {/* Option: Browse by Subjects */}
        <button
          className={`w-full flex items-center gap-2 border rounded-md p-3 mb-3 text-left ${
            selectedOption === "topic"
              ? "border-green-600 bg-green-50"
              : "border-gray-300"
          }`}
          onClick={() => setSelectedOption("topic")}
        >
          <FaSearch />
          <div>
            <div className="font-medium">Browse by Subjects</div>
            <div className="text-sm text-gray-500">
              Find games in specific categories
            </div>
          </div>
        </button>

        {selectedOption === "topic" && (
          <select
            value={selectedTopic}
            onChange={(e) => setSelectedTopic(e.target.value)}
            className="w-full border rounded-md p-2 mb-4"
          >
            <option value="">Choose a subject...</option>
            {topics?.map((topic) => (
              <option key={topic.id} value={topic.id}>
                {topic.subject_title}
              </option>
            ))}
          </select>
        )}

        {/* Option: Popular */}
        <button
          className={`w-full flex items-center gap-2 border rounded-md p-3 mb-3 text-left ${
            selectedOption === "popular"
              ? "border-green-600 bg-green-50"
              : "border-gray-300"
          }`}
          onClick={() => setSelectedOption("popular")}
        >
          <FaFire className="text-[#F07404]" />
          <div>
            <div className="font-medium">Popular Games</div>
            <div className="text-sm text-gray-500">
              See what’s trending right now
            </div>
          </div>
        </button>

        {/* Action Buttons */}
        <div className="flex gap-3 pt-4">
          <button
            onClick={onClose}
            className="flex-1 border rounded-md py-2 bg-gray-100 hover:bg-gray-200"
          >
            Not Now
          </button>
          <button
            onClick={handleExploreGames}
            disabled={
              !selectedOption || (selectedOption === "topic" && !selectedTopic)
            }
            className="flex-1 bg-[#F07404] text-white rounded-md py-2 hover:bg-green-700 disabled:opacity-50"
          >
            Explore Games
          </button>
        </div>
      </div>
    </div>
  );
}
